import React, { Suspense } from 'react';

import { lazyWithNullFallback } from 'components/layout/util';
import { useLoyaltyContext } from 'state/loyalty';

const LoyaltyOptInModalContent = lazyWithNullFallback(() =>
  import('pages/loyalty/loyalty-opt-in-modal/loyalty-opt-in-modal-content')
);

export default () => {
  const { loyaltyEnabled } = useLoyaltyContext();

  if (!loyaltyEnabled) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <LoyaltyOptInModalContent />
    </Suspense>
  );
};
